export class EquipmentCache {
  EquipmentId: number;
  EszNum : number;
  EquipmentName: string;
  // N: Nem HK-s eszköz; H: HK; M: Műszak; K: HK és műszak
  EquipmentKind: string;
  SData: string;
}